import Vue from "vue";
import vuetify from "./vuetify";
import VueTelInputVuetify from "./vue-tel-input-vuetify/lib";

Vue.use(VueTelInputVuetify, {
  vuetify,
});
